import { defineMessages } from 'react-intl';

export const messages: {
	search: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	search: {
		id: 'dropdown_search',
		defaultMessage: 'Search',
		description:
			'Subheading text displayed in the mimic-query dropdown section that prompts the user to search.',
	},
	searchIconLabel: {
		id: 'dropdown_search_icon_label',
		defaultMessage: 'Search',
		description:
			'Accessible label for the search icon displayed in the mimic-query dropdown on the search page.',
	},
});
